var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon2026(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Simple Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon=search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip_search_icon_2026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1497 55.1C49.1343 55.1 58.8497 45.3845 58.8497 33.4C58.8497 21.4154 49.1343 11.7 37.1497 11.7C25.1651 11.7 15.4497 21.4154 15.4497 33.4C15.4497 45.3845 25.1651 55.1 37.1497 55.1Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.3496 48.8999L68.9496 66.1999",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0498 17.3C35.7498 17.1 41.1498 16.9 46.2498 20.5C49.0498 22.5 50.6498 24.9 51.4498 26.4",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0498 17.3C35.7498 17.1 41.1498 16.9 46.2498 20.5C49.0498 22.5 50.6498 24.9 51.4498 26.4",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.1498 42.3L37.9498 42.1C37.7498 41.9 37.6498 41.7 37.5498 41.6C37.0498 41.3 36.5498 40.9 36.1498 40.4C35.6498 40.1 35.2498 39.7 34.8498 39.2C34.8498 39.1 34.7498 39.1 34.6498 39C34.5498 39 34.5498 38.9 34.4498 38.9C34.2498 38.7 34.0498 38.5 33.8498 38.3C33.4498 38 33.1498 37.6 32.8498 37.2H11.0498V68.4H39.2498V43.4C38.7498 43 38.4498 42.7 38.1498 42.3Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.6499 41.5H14.6499V49.3H29.6499V41.5Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.6499 54.3999H34.0499",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.6499 59.3999H34.0499",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.6499 63.7H26.1499",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M32.9497 37.0999L39.2497 42.9999H32.9497V37.0999Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_search_icon_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.9,
    height: 57.6,
    fill: "white",
    transform: "translate(10.5498 11.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2026);
export default __webpack_public_path__ + "static/media/search-icon-2026.ee8654ee14b26a8a39b8e53f98d28e89.svg";
export { ForwardRef as ReactComponent };